import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import blue from '../../assets/images/learn/mark_grp.svg';
import red from '../../assets/images/learn/mark_grp_rd.svg';

import './learn_styles/learnupper.css';
import Chartt from '../graph/chartt';

export default function LearnUpper() {
  return (
    <>
      <Container className='mt-5 mb-5 learn_upper'>
        <Row className='learn_up'>
              <Col lg={3} md={6} className='lrn_col'>
              <div className="ler_first_data ler_data d-flex align-items-center gap-2">
              <div className="ler_fst">
                <p>ET/USDT</p>
                <h6 className='m-0'>2.5026</h6>
                <span>$2.50</span>
              </div>
              <div className="ler_fst_grap">
                <Chartt />
              </div>
            </div>
              </Col>
            
              <Col lg={3} md={6} className='lrn_col'>
              <div className="ler_second_data ler_data d-flex align-items-center gap-2">
              <div className="ler_scnd">
                <p>ET/USDT</p>
                <h6 className='ler_up_h6 m-0'>2.5026</h6>
                <span>$2.50</span>
              </div>
              <div className="ler_scnd_grap">
               <Chartt />
              </div>
            </div>
              </Col>
           
            <Col lg={3} md={6} className='lrn_col'>
            <div className="ler_third_data ler_data d-flex align-items-center gap-2">
              <div className="ler_trd">
                <p>ET/USDT</p>
                <h6 className='m-0'>2.5026</h6>
                <span>$2.50</span>
              </div>
              <div className="ler_trd_grap">
                <Chartt />
              </div>
            </div>
            </Col>

            <Col lg={3} md={6} className='lrn_col'>
            <div className="ler_forth_data ler_data d-flex align-items-center gap-2">
              <div className="ler_fth">
                <p>ET/USDT</p>
                <h6 className='m-0'>2.5026</h6>
                <span>$2.50</span>
              </div>
              <div className="ler_fth_grap">
                <Chartt />
              </div>
            </div>            
            </Col>
        </Row>
      </Container>
    </>
  )
}
